export enum AccessLogAction {
    View = 0,
    List = 1,
    Export = 2,
    ViewHistory = 3
}
